import { Component, OnInit } from '@angular/core';
import { Companies } from '../../../_shared/interfaces';
import { AlertService, ContactsStoreService, IAlertType } from '../../../_shared/services';
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule} from '@clr/angular';

import { environment as env } from "../../../../environments/environment";
import { RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: 'app-contact-customers',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    ClrDatagridModule,
    ClrIconModule,
    TranslocoDirective
  ],
  templateUrl: './contact-customers.component.html',
  styleUrl: './contact-customers.component.sass'
})
export class ContactCustomersComponent implements OnInit {
  companies: Companies[] = [];
  descSort = ClrDatagridSortOrder.ASC;
  devMode: boolean;
  loading: boolean = false;

  constructor(
    private css: ContactsStoreService,
    private alertDispatcher: AlertService,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loading = true;
    this.loadList();
  }

  loadList() {
    this.css.getCustomers().subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Kundenkontakte gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.companies = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }
}
